import moment from 'moment';
import { getGlobalContacts } from '../../HttpRequests/globalContacts';
import { loadGlobalContacts } from '../State/globalContacts';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getGlobalContacts();
    
    dispatch(loadGlobalContacts(response.data.data));

  } catch (error) {
    
    throw error;

  }
}